<template>
  <article
    :id="id"
    :style="componentStyle"
    :class="componentClass"
  >
    <slot name="title">
      <h3 :class="titleClass">
        <a
          :href="`#${id}`"
          class="anchor"
        >
          <font-awesome-icon
            :icon="$v6.solid.faLinkHorizontal"
            size="xs"
          />
          <span class="sr-only">Link to "{{ title }}"</span>
        </a>

        {{ title }}
      </h3>
    </slot>

    <slot name="copy">
      <p><slot /></p>
    </slot>
  </article>
</template>

<script>
  export default {
    name: 'QuestionAndAnswer',

    props: {
      id: {
        type: String,
        required: true
      },
      customStyle: {
        type: Object,
        default: () => {}
      },
      title: {
        type: String,
        required: true
      },
      titleClass: {
        type: String,
        default: 'with-anchor h3 margin-top-0'
      }
    },

    computed: {
      componentClass() {
        return ['margin-bottom-5xl']
      },
      componentStyle() {
        return {
          ...this.customStyle
        }
      }
    }
  }
</script>
